import { createTranslationsHook } from '../lib/createTranslationsHook';

import { en } from './_en';
import { es } from './_es';

export const useTranslations = createTranslationsHook({ en, es });
